import { render, staticRenderFns } from "./params-form.vue?vue&type=template&id=e10c19ae&scoped=true&"
import script from "./params-form.vue?vue&type=script&lang=ts&"
export * from "./params-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10c19ae",
  null
  
)

export default component.exports